import { HttpClient } from "../HttpClient";
/**
 * * Get Contents
 */
export const GetGoogleSheetData = async (userId) => {
  try {
    const { data } = await HttpClient.get("api/contents/googleSheetData", {
      params: {
        userId: userId,
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
